module.exports = __webpack_public_path__ + "img/reset-password-desktop-ru.18ec8c4a.jpg";